import DeviceServiceClient from "../proto/generated/scavenger_grpc_web_pb";
import proto from "../proto/generated/scavenger_pb_formatted";
import { $auth } from "../main";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
let meta = {};
const tenant = ($auth && $auth.user[tenant_key] && $auth.user[tenant_key]["tenant"]) || "";

const token = localStorage.getItem("access_token");
if (token) {
  meta = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    Tenant: tenant,
    "Grpc-Encoding": "gzip",
  };
}
// const options = {
//   keepCase: true,
//   longs: String,
//   enums: String,
//   defaults: true,
//   oneofs: true,
// };

// function getChannelCredentials() {
//   const rootCert = fs.FileReadStream(path.resolve(__dirname, '../certs/ca-crt.crt'));

//   // If you use CA root certificate
//   // const channelCredentials = ChannelCredentials.createSsl();

//   // If you use Self-Signed root certificate you need to provide it
//   const channelCredentials = grpc.GrpcWebClientBase.ChannelCredentials.createSsl(rootCert);

//   return channelCredentials;
// }

// const credentials = getChannelCredentials();
// const ScavengerService = new DeviceServiceClient.ScavengerServiceClient(
//   "https://grpc-container-1.azurewebsites.net",
//   null
// );
// const ScavengerService = new DeviceServiceClient.ScavengerServiceClient("http://localhost:9090", null);

const ScavengerService = new DeviceServiceClient.ScavengerServiceClient(process.env["VUE_APP_ROOT_API_GRPC"], null);

export const scavenger_grpc_services = {
  GetScavengerOverview(device_id) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndDates();
      params.setDeviceId(device_id);
      ScavengerService.getScavengerOverview(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().overviewDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerOverviewStream(device_id) {
    let params = new proto.DeviceId();
    params.setDeviceId(device_id);
    let call = ScavengerService.getScavengerOverviewStream(params, meta);
    return call;
  },

  GetScavengerData(device_id = null, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndDates();
      params.setDeviceId(device_id);
      if (args && args.start_date) {
        params.setStartDate(args.start_date);
      }
      ScavengerService.getScavengerData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().deviceDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerList() {
    return new Promise((resolve, reject) => {
      let params = new proto.Empty();
      ScavengerService.getScavengerList(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().deviceDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerListStream(AggPeriod) {
    let params = new proto.AggPeriod();
    if (AggPeriod != null && AggPeriod > 0) {
      params.setAggPeriod(AggPeriod);
    }
    let call = ScavengerService.getScavengerListStream(params, meta);
    return call;
  },

  GetScvDeviceList() {
    return new Promise((resolve, reject) => {
      let params = new proto.Empty();
      ScavengerService.getScvDeviceList(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().deviceListDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerChartData(device_id, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndchartdata();
      params.setDeviceId(device_id);
      if (args) {
        if (args.start_date) {
          params.setStartDate(args.start_date);
        }
        if (args.charts) {
          params.setChartsList(args.charts);
        }
        if (args.types) {
          params.setTypesList(args.types);
        }
        if (args.end_date) {
          params.setEndDate(args.end_date);
        }
        if (args.aggregation) {
          params.setAggregation(args.aggregation);
        }
      }
      ScavengerService.getScavengerChartData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().scavengerChartDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetMinListData(device_id, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndDates();
      params.setDeviceId(device_id);
      if (args) {
        if (args.start_date) {
          params.setStartDate(args.start_date);
        }
        if (args.end_date) {
          params.setEndDate(args.end_date);
        }
      }
      ScavengerService.getMinListData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().minlistDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerDevOverview(duration) {
    return new Promise((resolve, reject) => {
      let params = new proto.Duration();
      params.setDuration(duration);
      ScavengerService.getScavengerDevOverview(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().devOverviewDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerBoxchartData(device_id, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndDates();
      params.setDeviceId(device_id);
      if (args) {
        if (args.start_date) {
          params.setStartDate(args.start_date);
        }
        if (args.num_days) {
          params.setDays(args.num_days);
        }
      }
      ScavengerService.getScavengerBoxchartData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().boxChartDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerTrendsData(device_id, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndchartdata();
      params.setDeviceId(device_id);
      if (args) {
        if (args.start_date) {
          params.setStartDate(args.start_date);
        }
        if (args.charts) {
          params.setChartsList(args.charts);
        }
        if (args.types) {
          params.setTypesList(args.types);
        }
        if (args.end_date) {
          params.setEndDate(args.end_date);
        }
        if (args.aggregation) {
          params.setAggregation(args.aggregation);
        }
      }
      ScavengerService.getScavengerTrendsData(params, meta, (err, response) => {
        if (!err) {
          console.log(response.toObject());
          resolve(response.toObject().customDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerVoltageData(device_id, args) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceIdAndDates();
      params.setDeviceId(device_id);
      if (args) {
        if (args.start_date) {
          params.setStartDate(args.start_date);
        }
      }
      ScavengerService.getScavengerVoltageData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().voltageDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetAccumulatedPowerData(device_id) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceId();
      params.setDeviceId(device_id);
      ScavengerService.getAccumulatedPowerData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().accPowerDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetEnrgyMtrData(device_id) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceId();
      params.setDeviceId(device_id);
      ScavengerService.getEnrgyMtrData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().enrgyMtrDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScvDonutData(time_frame, planner_group) {
    return new Promise((resolve, reject) => {
      let params = new proto.DurationAndPlannerGroup();
      if (time_frame) {
        if (time_frame.start_date) {
          params.setStartDate(time_frame.start_date);
        }
        if (time_frame.end_date) {
          params.setEndDate(time_frame.end_date);
        }
        if (time_frame.duration) {
          params.setDuration(time_frame.duration);
        }
      }
      if (planner_group) params.setPlannerGroup(planner_group);
      ScavengerService.getScvDonutData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject());
        } else {
          reject(err);
        }
      });
    });
  },

  GetScvCapacityDonutData(duration) {
    return new Promise((resolve, reject) => {
      let params = new proto.Duration();
      params.setDuration(duration);
      ScavengerService.getScvCapacityDonutData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().scvCapacityDonutDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerAvailableReportDates(id, type) {
    return new Promise((resolve, reject) => {
      let params = new proto.ScavengerReportFields();
      params.setType(type);
      params.setDeviceId(id);
      ScavengerService.getScavengerAvailableReportDates(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().scavengerAvailableReportDatesList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetEn50160Report(id, type, year, week) {
    return new Promise((resolve, reject) => {
      let params = new proto.ScavengerReportFields();
      params.setType(type);
      params.setDeviceId(id);
      params.setYear(year);
      params.setWeek(week);
      ScavengerService.getEn50160Report(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().en50160ReportDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetTempSensorInfo(device_id) {
    return new Promise((resolve, reject) => {
      let params = new proto.DeviceId();
      params.setDeviceId(device_id);
      ScavengerService.getTempSensorInfo(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().tempSensorInfoList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScvReportData() {
    return new Promise((resolve, reject) => {
      let params = new proto.Empty();
      ScavengerService.getScvReportData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().scvReportDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetInstalledDevicesReportData() {
    return new Promise((resolve, reject) => {
      let params = new proto.Empty();
      ScavengerService.getInstalledDevicesReportData(params, meta, (err, response) => {
        if (!err) {
          // console.log(response.toObject());
          resolve(response.toObject().installedDevicesReportDataList);
        } else {
          reject(err);
        }
      });
    });
  },

  GetScavengerAssetDataStream(payload) {
    let params = new proto.AssetPayload();
    if (payload.device_id != null && payload.device_id != "") {
      params.setDeviceId(payload.device_id);
    }
    if (payload.scavenger_data) {
      params.setScavengerData(payload.scavenger_data);
    }
    if (payload.minlist_data) {
      params.setMinlistData(payload.minlist_data);
    }
    if (payload.scavenger_overview) {
      params.setScavengerOverview(payload.scavenger_overview);
    }
    if (payload.chart_data) {
      params.setChartData(payload.chart_data);
    }
    // console.log(params);
    let call = ScavengerService.getScavengerAssetDataStream(params, meta);
    call.on("error", (err) => {
      console.log(err);
      call.cancel();
    });
    return call;
  },
};
